import React from 'react';
import { clinicInfo } from '../mockData';

const About = () => {
  return (
    <div className="min-h-screen bg-white pt-24">
      {/* Hero Section */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="heading-1 text-white mb-6">ABOUT US</h1>
            <p className="body-large text-gray-300">
              Three decades of excellence in dental care, combining experience with innovation
            </p>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="heading-2 text-gray-900 mb-8">OUR STORY</h2>
            <p className="body-medium text-gray-700 mb-6">
              Established in 1996, Dr. Kotecha's Dental Clinic has been serving the Kandivali 
              community for over {clinicInfo.experience} years. What started as a vision to provide 
              world-class dental care has grown into one of Mumbai's most trusted dental practices.
            </p>
            <p className="body-medium text-gray-700 mb-6">
              Our clinic combines the wisdom of decades of experience with cutting-edge dental 
              technology. We've invested in state-of-the-art equipment and continuously update 
              our techniques to ensure our patients receive the best possible care.
            </p>
            <p className="body-medium text-gray-700">
              From routine checkups to complex procedures, we approach every patient with the 
              same dedication to excellence and compassion that has defined us for three decades.
            </p>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="heading-2 text-white mb-8">WHY CHOOSE US</h2>
            
            <div className="grid md:grid-cols-2 gap-12 items-center mb-12">
              {/* Doctor Photo */}
              <div className="relative">
                <img
                  src="https://customer-assets.emergentagent.com/job_modern-dental-care-9/artifacts/6shgc60m_a0ebe0d4-4e31-4ffe-9349-957b891d5c47.jpg"
                  alt="Dr. Kalpesh Kotecha"
                  className="rounded-lg w-full h-auto object-cover"
                />
              </div>

              {/* Content */}
              <div className="space-y-6">
                <div>
                  <h3 className="heading-5 text-white mb-2">Advanced Treatment, Modern Equipment</h3>
                  <p className="body-small text-gray-400">Latest technology for accurate, painless and long-lasting results.</p>
                </div>

                <div>
                  <h3 className="heading-5 text-white mb-2">Complete Dental Care Under One Roof</h3>
                  <p className="body-small text-gray-400">From routine checkups to implants, braces, cosmetic fillings, smile designing.</p>
                </div>

                <div>
                  <h3 className="heading-5 text-white mb-2">Hygiene & Safety First</h3>
                  <p className="body-small text-gray-400">Strict sterilization and clean environment for your safety.</p>
                </div>

                <div>
                  <h3 className="heading-5 text-white mb-2">Affordable & Transparent Pricing</h3>
                  <p className="body-small text-gray-400">Quality treatment without hidden charges.</p>
                </div>

                <div>
                  <h3 className="heading-5 text-white mb-2">Friendly Staff & Comfortable Experience</h3>
                  <p className="body-small text-gray-400">We make sure you feel relaxed, not scared of the dentist.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Equipment Section */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="heading-1 text-white mb-6">
                STATE-OF-THE-ART EQUIPMENT
              </h2>
              <p className="body-medium text-gray-300 mb-6">
                We believe in providing the best care through the best technology. Our clinic 
                is equipped with the latest dental technology to ensure precise diagnostics 
                and effective treatments.
              </p>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-white rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <p className="body-small text-gray-300">Digital X-ray systems for reduced radiation exposure</p>
                </li>
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-white rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <p className="body-small text-gray-300">Advanced sterilization equipment for maximum safety</p>
                </li>
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-white rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <p className="body-small text-gray-300">Modern dental chairs with patient comfort features</p>
                </li>
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-white rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <p className="body-small text-gray-300">Rotary endodontic systems for painless root canals</p>
                </li>
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-white rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <p className="body-small text-gray-300">Intraoral cameras for better patient understanding</p>
                </li>
              </ul>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <img
                src="https://customer-assets.emergentagent.com/job_modern-dental-care-9/artifacts/ecqmgpfu_WhatsApp%20Image%202026-04-15%20at%2011.39.33%20AM_2.jpeg"
                alt="Modern Treatment Room"
                className="rounded-lg h-64 object-cover" />

              <img
                src="https://customer-assets.emergentagent.com/job_modern-dental-care-9/artifacts/5mxaxlq4_WhatsApp%20Image%202026-04-15%20at%2011.39.31%20AM.jpeg"
                alt="Advanced Dental Equipment"
                className="rounded-lg h-64 object-cover" />

            </div>
          </div>
        </div>
      </section>
    </div>);

};

export default About;